import IconArrowRight from 'assets/icons/arrow-right.svg';
import Button from 'components/button';
import LazyMotionWrapper from 'components/lazy-motion-wrapper';
import { AnimatePresence, m } from 'motion/react';
import React from 'react';

interface Props {
  visible: boolean;
  onClick: () => void;
}
const FunnelCta: React.FC<React.PropsWithChildren<Props>> = ({ visible, children, onClick }) => {
  return (
    <LazyMotionWrapper>
      <AnimatePresence>
        {visible && (
          <m.div
            initial={{ y: '100%' }}
            animate={{
              y: visible ? 0 : '100%',
            }}
            className="z-floating fixed bottom-0 left-0 w-screen px-4 pb-6 lg:sticky lg:z-10 lg:-mb-8 lg:w-auto lg:px-0 lg:pt-4 lg:pb-4"
          >
            <Button layout="brand" size="lg" className="w-full rounded-lg!" onClick={onClick}>
              <span className="flex justify-center">
                {children}
                <IconArrowRight className="text-other-white ml-4 h-4 w-auto lg:hidden" />
              </span>
            </Button>
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotionWrapper>
  );
};

export default FunnelCta;
